// @flow
import * as React from 'react';

import { editAutoMessageSftpCredentials } from 'admin/actions/AutoMessageSftpCredentialsActions';

type Props = {
  children: Function,
  sftpCredentials: ?*,
  orgUuid: string,
};

class AdminAutoMessageSftpCredentialsFormContainer extends React.Component<Props, void> {
  handleCredentialChange = (displayName: string) => {
    const { sftpCredentials, orgUuid } = this.props;
    if (!sftpCredentials || !sftpCredentials.credentials) {
      console.error(
        'AdminNewAutoMessageSftpCredentials - tried to edit credentials without username'
      );
      return;
    }
    editAutoMessageSftpCredentials(displayName, sftpCredentials.credentials.username, orgUuid);
  };

  render() {
    const { children } = this.props;

    return children({
      onCredentialChange: this.handleCredentialChange,
    });
  }
}

export { AdminAutoMessageSftpCredentialsFormContainer };

export default AdminAutoMessageSftpCredentialsFormContainer;
